<div [@showHide]="isNotificationReady ? 'show' : 'hide'">
  @if (notification && notification.show) {
  <notification
    [class]="notification.status === 'failure' ? '-colorAccentPink' : '-colorAccentLightBlue'"
    [title]="notification.title"
    [showDismissBtn]="true"
    (dismissNotification)="unsetNotification($event)">
    {{ notification.description }}
  </notification>
  }
</div>
<div class="-article-page-content">
  <div class="-left-pane" [class]="!isDocIndex ? '-full-width' : '-pane-width'">
    <div class="-docpage-content">
      @if (body) {
      <content-viewer [content]="body" (docRendered)="handleDocRendered($event)"> </content-viewer>
      }
    </div>
  </div>
  @if (isDocIndex) {
  <div class="-right-pane">
    <div class="sticky-right-pane">
      @if (isDocIndex && docIndexReady) {
      <doc-index [indexContainer]="'content-viewer'" [title]="'Within this Page'"></doc-index>
      }
    </div>
  </div>
  }
</div>

@if (requestNowConfirmModal) {
<div>
  <modal [visible]="true" (visibleChange)="closeConfirmModal()" [secondaryModal]="true" [title]="'Not logged in !'">
    <div>
      <p class="-fontSmall -colorAccentGrey -description-padding">You must login to access this feature</p>
      <div>
        <wpbutton type="submit" to="/dashboard/login">Login</wpbutton>
        <wpbutton type="submit" to="/dashboard/create-account">Create a free account</wpbutton>
      </div>
    </div>
  </modal>
</div>
}
